import { classNames, Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

export type CloseButtonProps = {
  onClick?: (e: MouseEvent) => void;
  size: "sm" | "md" | "lg";
  theme?: "light" | "dark";
};

@tag("nw-close-button")
export class NWCloseButton extends Component<CloseButtonProps> {
  static css = [tailwind];
  static propTypes = {
    onClick: Function,
    size: String,
    theme: String,
  };

  render({ onClick, theme = "light", size }: CloseButtonProps) {
    return (
      <button
        onClick={onClick}
        class={classNames(
          "cursor-pointer p-2 rounded-lg justify-center items-center inline-flex transition-all outline-none focus-visible:ring focus-visible:ring-brand-500",
          { "w-9 h-9": size === "sm" },
          { "w-10 h-10": size === "md" },
          { "w-11 h-11": size === "lg" },
          {
            "text-quinary hover:bg-gray-50 hover:text-quinary-hover": theme === "light",
          },
          {
            "text-gray-50 bg-gray-800 hover:bg-gray-900 hover:text-gray-50 ": theme === "dark",
          },
        )}
      >
        <div
          class={classNames("justify-center items-center flex", {
            "w-5 h-5": size === "sm",
            "w-5 h-5 p-1": size === "md",
            "w-6 h-6 p-1.5": size === "lg",
          })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M11 1L1 11M1 1L11 11"
              stroke="currentColor"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </button>
    );
  }
}
